export enum PictureStatus {
  Pending = 'Pendiente',
  Valid = 'Valida',
  Invalid = 'Invalida'
}
